export default "__VITE_ASSET__17bbc47b__"